/**
 * "Message" beside Book on a salon's (or a stylist's) booking page: a
 * question before booking (approved mockup "Message the salon before
 * booking"). Small on purpose: the sheet and the Messages code load on the
 * first tap, so the public booking page carries none of it.
 */
import React, { Suspense, lazy, useState } from 'react';
import { hapticTick } from '../../../_utils/haptics';
import './message-salon.css';

const MessageSalonSheet = lazy(() => import('./MessageSalonSheet'));

const ChatIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    </svg>
);

/** target: { id, name } the salon, or the self-employed stylist on their own page. */
export default function MessageSalonButton({ target, className = '', onBook, canBook }) {
    const [open, setOpen] = useState(false);
    if (!target || !target.id) return null;
    return (
        <>
            <button type="button" className={`bm-msg-salon-btn ${className}`} onClick={() => { hapticTick(); setOpen(true); }}>
                <ChatIcon />Message
            </button>
            {open && (
                <Suspense fallback={null}>
                    <MessageSalonSheet target={target} onClose={() => setOpen(false)} onBook={onBook} canBook={canBook} />
                </Suspense>
            )}
        </>
    );
}
